import React from 'react';

import { useUnit } from 'effector-react';
import { useNavigate } from 'react-router-dom';
import Select from 'react-select';

import { StrategiesForList$ } from '../../effector/strategies';
import { PAGE_STRATEGIES, PAGE_STRATEGY_POSITIONS } from '../Routes';

export const Strategies: React.FC = () => {
  const navigate = useNavigate();
  const strategies = useUnit(StrategiesForList$);

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  const handleChange = (val) => {
    navigate(`${PAGE_STRATEGIES}/${val.id}/${PAGE_STRATEGY_POSITIONS}`);
  };

  return (
    <div className="strategies">
      <div className="strategies__selection">
        <Select
          placeholder="Выберите стратегию"
          options={strategies}
          getOptionLabel={(option) => option.name}
          onChange={handleChange}
        />
      </div>
    </div>
  );
};
